import { RouteDialog } from './RouteDialog';

export const CreateRoute = () => {
  return <RouteDialog mutateType="create"></RouteDialog>;
};
